/**
 * 示例-编辑页-普通编辑页
 * luxinwen
 * 2023-01
 */
<template>
  <div class="page">
    <div class="page-main">
      <div class="page-main-content">
        <Form ref="editForm" :model="formData" :rules="formRule" :label-width="110">
          <FormItem label="商品名称" prop="name">
            <Input v-model.trim="formData.name" class="width-l" maxlength="30" clearable />
          </FormItem>
          <FormItem label="商品状态" prop="status">
            <Select v-model="formData.status" class="width-s" clearable>
              <Option v-for="(value, key) in statusList" :key="'status' + key" :value="key">{{ value }}</Option>
            </Select>
          </FormItem>
          <FormItem label="商品价格" prop="price">
            <InputNumber v-model="formData.price" :min="0" :max="10000000" />
          </FormItem>
          <FormItem label="促销时间" prop="time">
            <DatePicker v-model="formData.time" class="width-s" type="datetime" />
          </FormItem>
        </Form>
      </div>
    </div>
    <sp-footer>
      <Button type="primary" :loading="btnLoading" @click="submit">提交</Button>
      <Button @click="cancel">返回</Button>
    </sp-footer>
  </div>
</template>

<script>
  import { TEST_STATUS } from '@/util/enum';

  export default {
    data() {
      return {
        pageFlag: 'add',    // 页面状态，可选值为 add（新增），edit（编辑），show（查看）
        dataId: '',         // 数据ID
        btnLoading: false,  // 按钮状态
        formData: {
          name: '',
          status: '',
          price: null,
          time: ''
        },
        formRule: {
          name: [
            {
              required: true,
              message: '请输入商品名称',
              trigger: 'blur'
            }
          ],
          status: [
            {
              required: true,
              message: '请选择商品状态',
              trigger: 'change'
            }
          ],
          price: [
            {
              ype: 'number',
              required: true,
              message: '请输入商品价格',
              trigger: 'blur'
            }
          ],
          time: [
            {
              type: 'date',
              required: true,
              message: '请选择促销时间',
              trigger: 'change'
            }
          ]
        },
        statusList: TEST_STATUS
      };
    },
    created() {
      if (this.$route.name.indexOf('Edit') !== -1) {
        this.pageFlag = 'edit';
        this.dataId = this.$route.query.id;
      } else if (this.$route.name.indexOf('Show') !== -1) {
        this.pageFlag = 'show';
        this.dataId = this.$route.query.id;
      }
      if (this.dataId) {
        this.getData();
      }
    },
    methods: {
      /**
       * 获取数据
       */
      getData() {
        this.$axios({
          url: this.$api.test.queryTestDetail,
          mock: true,
          data: {
            id: this.dataId
          },
          loading: true
        }).then(data => {
          Object.keys(this.formData).forEach(item => {
            if (data.hasOwnProperty(item)) {
              this.formData[item] = data[item];
            }
          });
        });
      },
      /**
       * 提交
       */
      submit() {
        this.$refs.editForm.validate(valid => {
          if (valid) {
            this.$confirm('确定要提交吗？').then(() => {
              let url = this.$api.test.addTest;
              let params = Object.assign({}, this.formData);
              if (this.pageFlag === 'edit' && this.dataId) {
                url = this.$api.test.updateTest;
                params.id = this.dataId;
              }
              this.save(url, params);
            });
          }
        });
      },
      /**
       * 保存
       */
      save(url, data) {
        this.$axios({
          url,
          data,
          beforeSend: () => {
            this.btnLoading = true;
          },
          complete: () => {
            this.btnLoading = false;
          }
        }).then(data => {
          this.notice({
            type: 'success',
            desc: '提交成功'
          });
          this.$router.push({
            name: 'testList'
          });
        });
      },
      /**
       * 返回
       */
      cancel() {
        this.$router.go(-1);
      }
    }
  };
</script>